import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import { Errors } from 'components/ui/errors';
import debounce from 'lodash/debounce';
import { put } from 'helpers/api';

import './styles/defaults_editor.scss';

export default class PipelineDefaultsEditor extends React.Component {
  static propTypes = {
    companyPipelineSettingsPath: PropTypes.string.isRequired,
    percentageLikelyToCloseDefaults: PropTypes.shape({
      proposal: PropTypes.number,
      onMarket: PropTypes.number,
      underContract: PropTypes.number,
    }).isRequired,
  }

  state = {
    percentageLikelyToCloseDefaults: {
      proposal: this.props.percentageLikelyToCloseDefaults.proposal,
      onMarket: this.props.percentageLikelyToCloseDefaults.onMarket,
      underContract: this.props.percentageLikelyToCloseDefaults.underContract,
    },
  }

  debouncedSave = debounce(() => {
    const { percentageLikelyToCloseDefaults } = this.state;

    put(this.props.companyPipelineSettingsPath, { percentageLikelyToCloseDefaults })
      .then(() => {
        clearTimeout(this.state.successFadeId);
        this.setState({
          success: true,
          savedAtLeastOnce: true,
          successFadeId: setTimeout(() => this.setState({ success: false }), 1000),
        });
      })
      .catch(errors => this.setState({ errors }));
  }, 500);

  handleChange = (change) => {
    this.setState(({ percentageLikelyToCloseDefaults }) => ({
      percentageLikelyToCloseDefaults: {
        ...percentageLikelyToCloseDefaults,
        ...change,
      },
      errors: null,
    }), this.debouncedSave);
  }

  render() {
    return <React.Fragment>
      {this.renderHeader()}
      <div className="row pipeline-settings">
        <div className="col-6 d-flex flex-column gap-3">
          {this.renderInput('proposal', 'Proposal', 'proposal')}
          {this.renderInput('onMarket', 'Active / Touring', 'on-market')}
          {this.renderInput('underContract', 'Under Contract', 'under-contract')}
          {this.renderInput('closed', 'Closed', 'closed', 100)}
        </div>
      </div>
    </React.Fragment>;
  }

  renderHeader() {
    return <React.Fragment>
      <h5>
        Pipeline Settings
        {this.renderSuccess()}
      </h5>
      <p>Set default prediction values for your pipeline</p>
      <Errors className="mb-3" errors={this.state.errors} />
    </React.Fragment>;
  }

  renderInput(name, label, className, value) {
    return (
      <div>
        <div className={`pipeline-setting-header ${className} fs-large ps-2 mb-1`}>{label}</div>
        <ManagedFormGroup
          disabled={!!value}
          label="% likely to close"
          max="100"
          min="1"
          name={name}
          type="number"
          value={value || this.state.percentageLikelyToCloseDefaults[name]}
          onChange={this.handleChange}
        />
      </div>
    );
  }

  renderSuccess() {
    const { success, savedAtLeastOnce } = this.state;
    const className = classNames('success-notification', 'text-success', 'ms-4', { visible: success });

    if (savedAtLeastOnce) {
      return (
        <small className={className} name="success-message">
          <FontAwesomeIcon className="me-2" icon={faCheck} />
          Changes saved successfully
        </small>
      );
    }
  }
}
